<template>
  <el-cascader v-if="isEdit" ref="region" size="mini" v-model="address" style="width: 100%;" :placeholder="$t('portal.qu-yu')" popper-class="region-picker" filterable :filter-method="dataFilter" :props="props" :options="regionList" @change="handleChange" class="cascader-region"></el-cascader>
  <span v-else>{{addressText}}</span>
</template>

<script>
/**
 * 国家-省份-市 3级选择器
 * 说明：
 * 支持el-form-item 双向数据绑定
 * <region v-model="ids"></region>
 * 参数为 [国家id, 省份id, 市id]
 * @param isEdit Boolean 值为false时支持地址id解析为地址
 */


import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      regionList: state => state.regionList
    }),
    addressText() {
      const { value, regionList } = this;

      if (typeof value === 'string') {
        return '';
      }

      const regionObj = {};
      regionList.forEach(({ value, label, children }) => {
        regionObj[value] = label;
        children && children.forEach(({ value, label, children }) => {
          regionObj[value] = label;
          children && children.forEach(({ value, label }) => {
            regionObj[value] = label;
          });
        });
      });

      return value.map(id => regionObj[id]).join('');
    }
  },
  props: {
    props: {
      type: Object,
      default: () => ({ checkStrictly: false })
    },
    value: {
      type: [Array, String],
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      address: [],
    };
  },
  created() {
    // vuex中没有地址数据则请求
    if (this.regionList.length === 0) {
      this.$store.dispatch('getRegionList');
    }
    // 国家、省、市 id
    if (this.value) {
      this.address = this.value.filter(item => item != "0");
    }
  },
  watch: {
    value(v) {
      if (this.value) {
        this.address = this.value.filter(item => item != "0");
      } else {
        this.address = [];
      }
    },
  },
  methods: {
    handleChange(ids) {
      this.$nextTick(() => {
        let nodesText = this.$refs['region'].getCheckedNodes()[0].pathNodes[0].label;//获取第一个节点的文本
        this.$emit('input', ids, nodesText);
      })
    }, 
    dataFilter(node, keyword) {
      if (!!~node.text.indexOf(keyword) || !!~node.text.toUpperCase().indexOf(keyword.toUpperCase())) {
        return true;
      }
    },
  }
}
</script>
<style>
.error-deal .el-col .addresses_wrapper .cascader-region + .el-form-item__error {
	top: -25px;
}
</style>
<style lang="less" scoped>
.region-picker ul > li > label {
  display: none;
}

</style>
